/**
 * Empty function
 * @type {Function}
 */
const noop = () => {}

module.exports = noop
